import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function SalesLetterContainer() {
  return <section className="w-full px-5 md:px-8 py-20 md:py-32 bg-base" data-id="element-135">
      <div className="max-w-2xl mx-auto" data-id="element-136">
        <div className="mb-16 pb-8 border-b border-ink/10" data-id="element-137">
          <p className="text-[11px] md:text-xs font-semibold text-ink/60 uppercase tracking-[0.2em]" data-id="element-138">
            De la mesa de la Fundadora de MOVÉ SUAVE™
            <br data-id="element-139" />
            <span className="text-primary mt-1 block" data-id="element-140">
              Re: Volver a sentirte bien en tu cuerpo
            </span>
          </p>
        </div>

        <div className="prose prose-lg prose-p:text-ink/80 prose-p:leading-[1.75] prose-p:text-[17px] md:prose-p:text-lg prose-p:mb-8 max-w-none" data-id="element-141">
          <p className="font-medium text-xl mb-10 text-ink" data-id="element-142">
            Querida amiga, querido amigo,
          </p>

          <p className="drop-cap" data-id="element-143">
            Sé exactamente cómo te sentís. Sé lo que es despertarse con el
            cuerpo pesado, rígido, y pensar "hoy sí voy a entrenar", solo para
            llegar al final del día sin energía, sintiendo que{' '}
            <strong className="font-semibold text-ink" data-id="element-144">
              volviste a fallar
            </strong>
            .
          </p>

          <div className="my-16 bg-secondary/40 p-8 md:p-10 rounded-2xl" data-id="element-145">
            <h3 className="font-serif text-2xl md:text-3xl mb-8 text-ink leading-[1.1] tracking-tight" data-id="element-146">
              ¿Alguna vez te pasó que…?
            </h3>
            <ul className="space-y-5" data-id="element-147">
              {['¿Empezaste rutinas con toda la ilusión y a los días las abandonaste sintiéndote peor?', '¿Te sentís rígida, pesada, desconectada de tu propio cuerpo?', '¿Cada video de ejercicio que probás te deja más agotada y con más culpa?', "¿Sentís que 'fallaste' otra vez, cuando en realidad el sistema falló con vos?", '¿Querés moverte, pero no tenés energía — y eso te hace sentir aún peor?'].map((bullet, i) => <li key={i} className="flex items-start gap-4" data-id="element-148">
                  <X className="w-6 h-6 text-pain shrink-0 mt-0.5" data-id="element-149" />
                  <span className="text-[17px] md:text-lg text-ink/90 font-medium leading-[1.6]" data-id="element-150">
                    {bullet}
                  </span>
                </li>)}
            </ul>
          </div>

          <p data-id="element-151">
            Estos eran exactamente los problemas que me rompían el corazón ver
            en mis alumnas… hasta que entendí algo que lo cambió todo:
          </p>

          <blockquote className="my-16 border-l-4 border-primary pl-6 md:pl-8 py-2" data-id="element-152">
            <p className="font-serif italic text-3xl md:text-4xl text-primary leading-[1.1] tracking-tight m-0" data-id="element-153">
              "Moverse bien no tiene que doler. Y sostenerlo no tiene que
              costarte la vida."
            </p>
          </blockquote>

          <div className="mb-20" data-id="element-154">
            <p className="font-medium text-ink text-lg" data-id="element-155">— Fundadora</p>
            <p className="text-sm text-ink/60 mt-1" data-id="element-156">
              Creadora de MOVÉ SUAVE™, especialista en movimiento suave y
              bienestar emocional
            </p>
          </div>

          <h2 className="font-serif text-3xl md:text-4xl text-ink mb-8 mt-20 leading-[1.1] tracking-tight" data-id="element-157">
            El 90% del wellness que ves por ahí es{' '}
            <span className="highlight" data-id="element-158">BASURA emocional</span>.
          </h2>

          <p data-id="element-159">
            Y te lo digo así de directo porque estoy cansada de ver cómo la
            industria del fitness te hace sentir que el problema sos vos. Te
            venden rutinas agresivas que te culpabilizan, programas de "todo o
            nada", y gurúes que asumen que tenés energía infinita y cero
            problemas en tu vida.
          </p>

          <p data-id="element-160">
            Te venden sistemas rotos. Programas largos imposibles de mantener. Y
            cuando no podés seguirlos, te dejan con una sensación de{' '}
            <strong className="font-semibold text-ink" data-id="element-161">fracaso terrible</strong>
            .
          </p>

          <div className="my-12" data-id="element-162">
            <ul className="space-y-5" data-id="element-163">
              {['Rutinas fitness agresivas que te dejan peor que antes.', "Programas 'todo o nada' que generan culpa el primer día que fallás.", 'Videos de ejercicio que asumen que tenés 1h libre y energía de sobra.', 'Métodos diseñados para cuerpos ideales, no cuerpos reales.', 'Wellness falso que te vende presión disfrazada de autocuidado.'].map((bullet, i) => <li key={i} className="flex items-start gap-4" data-id="element-164">
                  <X className="w-5 h-5 text-pain shrink-0 mt-1 opacity-70" data-id="element-165" />
                  <span className="text-[17px] md:text-lg text-ink/80 leading-[1.6]" data-id="element-166">
                    {bullet}
                  </span>
                </li>)}
            </ul>
          </div>

          <p className="font-medium text-xl md:text-2xl text-ink leading-[1.6] my-12" data-id="element-167">
            <em className="italic font-serif text-primary" data-id="element-168">No es tu culpa.</em>{' '}
            Es que todo lo que probaste estaba diseñado para fallar con vos.
          </p>

          <h2 className="font-serif text-3xl md:text-4xl text-ink mb-8 mt-20 leading-[1.1] tracking-tight" data-id="element-169">
            Así que decidí resolverlo…
          </h2>

          <p data-id="element-170">
            Después de años acompañando a personas reales, creé un sistema que
            funciona AL REVÉS de todo lo que viste antes. Un sistema que te
            abraza en tus peores días en lugar de exigirte.
          </p>
        </div>
      </div>
    </section>;
}